import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGetSection() {
  const deliverables = ['Guía Completa del Protocolo 21 Días (PDF)', 'Plan de Alimentación Anti-Inflamatorio (Sin dietas)', 'Ejercicios Somáticos (5 min/día)', 'Tracker de Hábitos y Progreso', 'Lista de Compras Económica y Simple', 'BONUS: Guía de Emergencia para Días Hinchados'];
  return <section className="py-20 bg-beige-50" data-id="element-250">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-251">
        <div className="flex flex-col lg:flex-row items-center gap-12 max-w-6xl mx-auto" data-id="element-252">
          <div className="lg:w-1/2 order-2 lg:order-1" data-id="element-253">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-8" data-id="element-254">
              Todo lo que necesitas para recuperar tu cuerpo
            </h2>

            <div className="space-y-4" data-id="element-255">
              {deliverables.map((item, index) => <div key={index} className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm border border-beige-100" data-id="element-256">
                  <CheckCircle2 className="w-6 h-6 text-sage-500 flex-shrink-0 mt-0.5" data-id="element-257" />
                  <span className="text-charcoal font-medium text-lg" data-id="element-258">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="lg:w-1/2 order-1 lg:order-2" data-id="element-259">
            <div className="relative" data-id="element-260">
              <div className="absolute inset-0 bg-sage-200 rounded-full filter blur-3xl opacity-40 animate-pulse" data-id="element-261"></div>
              <img src="https://cdn.magicpatterns.com/uploads/9ndyngNhDftSJYwFT5LScV/heylloyd-image-1772188307774.png" alt="Mockup de los materiales del curso" className="relative w-full h-auto transform hover:scale-105 transition-transform duration-500 drop-shadow-2xl" data-id="element-262" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}